export enum HttpMethod {
  GET = 'GET',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
  POST = 'POST',
}
